(function () {
    var sectionSelector = '.npbp-bundle-tab-product';

    function setActiveById(triggers, panels, attr, id) {
        triggers.forEach(function (trigger) {
            trigger.classList.toggle('active', trigger.getAttribute(attr) === id);
        });
        panels.forEach(function (panel) {
            panel.classList.toggle('active', panel.getAttribute(attr) === id);
        });
    }

    function moveTabTriggers(fromRoot, toRoot, triggerSelector) {
        if (!fromRoot || !toRoot) return;
        fromRoot.querySelectorAll(triggerSelector).forEach(function (el) {
            toRoot.appendChild(el);
        });
    }

    function initSection(section) {
        if (!section || section.dataset.npbpTabProductBound === 'true') return;
        section.dataset.npbpTabProductBound = 'true';

        var abortController = new AbortController();
        var signal = abortController.signal;
        section._npbpTabProductAbort = abortController;

        var parentTabsRoot = section.querySelector('.npbp-bundle-tab-product__tabs');
        var contentsRoot = section.querySelector('.npbp-bundle-tab-product__contents');
        moveTabTriggers(contentsRoot, parentTabsRoot, '.npbp-btp-group__block-tab-trigger');

        section.querySelectorAll('.npbp-btp-group__block-content').forEach(function (content) {
            var groupId = content.getAttribute('data-npbpg-id');
            var tabsEl = content.querySelector('.npbp-btp-group__tabs');
            var productsEl = section.querySelector('.npbp-btp-group__products[data-npbpg-id="' + groupId + '"]');
            moveTabTriggers(productsEl, tabsEl, '.npbp-btp-group-products__tab-trigger');
        });

        function alignProductCardInfoHeight() {
            var activeCards = section.querySelectorAll(
                '.npbp-btp-group__products.npbpgb-content.active .npbp-btp-group-products__cards.active'
            );
            if (!activeCards.length) return;
            activeCards.forEach(function (cards) {
                var productIntros = cards.querySelectorAll('.npbp-btp-group-product__intro');
                if (!productIntros.length) return;
                var maxH = 0;
                productIntros.forEach(function (el) {
                    var h = el.offsetHeight || el.getBoundingClientRect().height || el.scrollHeight;
                    if (h > maxH) maxH = h;
                });
                var root = cards.closest('.npbp-btp-group__products') || section;
                root.style.setProperty('--max-prod-info-height', maxH + 'px');
            });
        }

        function alignProductCardInfoHeightAsync() {
            requestAnimationFrame(function () {
                requestAnimationFrame(alignProductCardInfoHeight);
            });
        }

        function activateFirstChildOfGroup(groupId) {
            var content = section.querySelector('.npbp-btp-group__block-content[data-npbpg-id="' + groupId + '"]');
            var products = section.querySelector('.npbp-btp-group__products[data-npbpg-id="' + groupId + '"]');
            if (!content || !products) return;
            var childTabs = content.querySelectorAll('.npbp-btp-group-products__tab-trigger');
            var childCards = products.querySelectorAll('.npbp-btp-group-products__cards');
            if (!childTabs.length) return;
            setActiveById(childTabs, childCards, 'data-npbpgps-id', childTabs[0].getAttribute('data-npbpgps-id'));
        }

        function initParentTabs() {
            var tabs = section.querySelectorAll('.npbp-bundle-tab-product__tabs .npbp-btp-group__block-tab-trigger');
            var contents = section.querySelectorAll('.npbpgb-content');
            if (!tabs.length) return;

            function activateParent(tab) {
                var id = tab.getAttribute('data-npbpg-id');
                setActiveById(tabs, contents, 'data-npbpg-id', id);
                activateFirstChildOfGroup(id);
                alignProductCardInfoHeightAsync();
            }

            tabs.forEach(function (tab) {
                tab.addEventListener('click', function () {
                    activateParent(tab);
                }, { signal: signal });
            });

            activateParent(tabs[0]);
        }

        function initChildTabs() {
            section.querySelectorAll('.npbp-btp-group__block-content').forEach(function (content) {
                var groupId = content.getAttribute('data-npbpg-id');
                var products = section.querySelector('.npbp-btp-group__products[data-npbpg-id="' + groupId + '"]');
                if (!products) return;
                var childTabs = content.querySelectorAll('.npbp-btp-group-products__tab-trigger');
                var childCards = products.querySelectorAll('.npbp-btp-group-products__cards');

                childTabs.forEach(function (tab) {
                    tab.addEventListener('click', function () {
                        setActiveById(childTabs, childCards, 'data-npbpgps-id', tab.getAttribute('data-npbpgps-id'));
                        alignProductCardInfoHeightAsync();
                    }, { signal: signal });
                });
            });
        }

        function initStickyTabs() {
            var tabs = section.querySelector('.npbp-bundle-tab-product__tabs');
            if (!tabs) return;

            var paddingTop = parseInt(window.getComputedStyle(section).paddingTop, 10) || 0;
            var ticking = false;

            function onScroll() {
                var sectionTop = section.getBoundingClientRect().top + window.scrollY;
                var triggerStart = sectionTop + paddingTop;
                var visibleProducts = section.querySelector(
                    '.npbp-btp-group__products.npbpgb-content.active .npbp-btp-group-products__cards.active'
                );

                if (!visibleProducts) {
                    tabs.classList.remove('fixed');
                    return;
                }

                var productsTop = visibleProducts.getBoundingClientRect().top;
                if (window.scrollY >= triggerStart && productsTop > 0) {
                    tabs.classList.add('fixed');
                } else {
                    tabs.classList.remove('fixed');
                }
            }

            window.addEventListener('scroll', function () {
                if (ticking) return;
                ticking = true;
                requestAnimationFrame(function () {
                    onScroll();
                    ticking = false;
                });
            }, { passive: true, signal: signal });

            window.addEventListener('resize', function () {
                paddingTop = parseInt(window.getComputedStyle(section).paddingTop, 10) || 0;
                onScroll();
            }, { passive: true, signal: signal });

            onScroll();
        }

        function bindScrollIntoCenter(scrollerSelector, triggerSelector) {
            var scroller = section.querySelector(scrollerSelector);
            if (!scroller || window.innerWidth >= 769) return;
            var triggers = section.querySelectorAll(triggerSelector);
            if (!triggers.length) return;

            function center(tab) {
                requestAnimationFrame(function () {
                    var tabCenter = tab.offsetLeft + tab.offsetWidth / 2;
                    var scrollerCenter = scroller.clientWidth / 2;
                    scroller.scrollTo({
                        left: tabCenter - scrollerCenter,
                        behavior: 'smooth'
                    });
                });
            }

            triggers.forEach(function (tabEl) {
                tabEl.addEventListener('click', function () {
                    center(tabEl);
                }, { signal: signal });
            });
        }

        function bindAtc() {
            section.addEventListener('click', function (e) {
                var btn = e.target.closest('.atc-btn');
                if (!btn || !section.contains(btn)) return;
                e.preventDefault();

                var buttonElement = btn.querySelector('.icon-cart');
                var loaderElement = btn.querySelector('.loader');
                if (buttonElement) buttonElement.style.display = 'none';
                if (loaderElement) loaderElement.classList.remove('hide');

                fetch('/cart/add.js', {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        items: [{ id: btn.getAttribute('data-variant-id'), quantity: 1 }]
                    })
                })
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function () {
                        if (window.theme && theme.Cart && theme.Cart.prototype && typeof theme.Cart.prototype._onProductAdded === 'function') {
                            theme.Cart.prototype._onProductAdded();
                        }
                    })
                    .finally(function () {
                        if (buttonElement) buttonElement.style.display = 'block';
                        if (loaderElement) loaderElement.classList.add('hide');
                    });
            }, { signal: signal });
        }

        initChildTabs();
        initParentTabs();
        bindScrollIntoCenter('.npbp-bundle-tab-product__tabs', '.npbp-btp-group__block-tab-trigger');
        initStickyTabs();
        bindAtc();
    }

    function findSection(root) {
        if (!root) return null;
        if (root.matches && root.matches(sectionSelector)) return root;
        return root.querySelector ? root.querySelector(sectionSelector) : null;
    }

    function destroySection(root) {
        if (!root) return;
        var sections = [];
        if (root.matches && root.matches(sectionSelector)) {
            sections = [root];
        } else if (root.querySelectorAll) {
            sections = Array.prototype.slice.call(root.querySelectorAll(sectionSelector));
        }
        sections.forEach(function (sectionEl) {
            if (sectionEl._npbpTabProductAbort) {
                sectionEl._npbpTabProductAbort.abort();
                sectionEl._npbpTabProductAbort = null;
            }
            delete sectionEl.dataset.npbpTabProductBound;
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll(sectionSelector).forEach(initSection);
    });

    document.addEventListener('shopify:section:load', function (event) {
        var section = findSection(event.target);
        if (section) {
            delete section.dataset.npbpTabProductBound;
            initSection(section);
        }
    });

    document.addEventListener('shopify:section:unload', function (event) {
        destroySection(event.target);
    });
})();
